import { projectPermissionKeys } from '../shared/utils/permissions'

const projectId = 'project-a'

const emptyProject = {
  id: projectId,
  code: '项目 A',
  name: '未命名项目',
  accent: '#6653d7',
  demoDate: '2026-07-22',
  storageLimitGb: 100,
  notificationLeadMinutes: 15,
  integrations: { wecom: false, douyin: false, xiaohongshu: false, wechat: false },
}

const owner = {
  id: 'member-fei',
  projectId,
  name: 'Fei',
  email: 'fei@matrix.local',
  role: 'owner',
  status: 'active',
  initials: 'FE',
  projectIds: [projectId],
  permissionsByProject: { [projectId]: projectPermissionKeys },
}

export function createSeedData() {
  return {
    version: 5,
    currentProjectId: projectId,
    currentMemberId: owner.id,
    projects: [structuredClone(emptyProject)],
    members: [structuredClone(owner)],
    devices: [],
    accounts: [],
    products: [],
    skus: [],
    templates: [],
    references: [],
    assets: [],
    assetPublications: [],
    plans: [],
    publishSettings: [],
    notifications: [],
  }
}
